import { defineStore } from 'pinia';
import { ref, shallowRef } from 'vue';
import { useLocalStorage } from '@src/utils/storage';

/** 商圈地图版本项（自定义 drawMapId 或已发布 version） */
export interface MapVersionItem {
    label: string | number;
    name?: string;
    /** '1' 自定义地图 | '2' 已发布版本 */
    type: string;
    isDefaultFlag?: string;
}

export const useStoreMapVersion = defineStore('mapVersion', () => {
    /** 当前选中的商圈版本（持久化） */
    const mapVersion = useLocalStorage<MapVersionItem | null>('mapVersion', null);

    /** 可选版本列表（内存，由 useMapVersion.init 拉取一次） */
    const versionList = shallowRef<MapVersionItem[]>([]);

    /** 版本列表是否已拉取完成 */
    const isVersionListReady = ref(false);

    const setVersionList = (list: MapVersionItem[]) => {
        versionList.value = list;
        isVersionListReady.value = true;
    };

    const setMapVersion = (version: MapVersionItem | null) => {
        mapVersion.value = version;
    };

    const clearMapVersion = () => {
        mapVersion.value = null;
    };

    const resetVersionState = () => {
        mapVersion.value = null;
        versionList.value = [];
        isVersionListReady.value = false;
    };

    return {
        mapVersion,
        versionList,
        isVersionListReady,
        setVersionList,
        setMapVersion,
        clearMapVersion,
        resetVersionState,
    };
});
